import RemoveItemModal from './RemoveItemModal';

export default RemoveItemModal;
